<div class="ds-modal ds-modal--auto clave">
  <div class="ds-accent"></div>

  <div class="ds-modal__head">
    <span class="ds-modal__head-icon material-icons">lock</span>
    <div>
      <h2>Modificar contraseña</h2>
      <p>Asigná una nueva contraseña al usuario.</p>
    </div>
    <span class="ds-modal__spacer"></span>
    <button type="button" class="ds-icon-btn" (click)="closeModal()" aria-label="Cerrar">
      <span class="material-icons">close</span>
    </button>
  </div>

  <div class="ds-modal__body">
    <form [formGroup]="form" (ngSubmit)="actualizarClave()">
      <div class="ds-card">
        <div class="ds-section__head">
          <span class="material-icons">key</span>
          Nueva contraseña
        </div>
        <div class="ds-section__body">
          <div class="ds-field">
            <label class="ds-field__label" for="clave-nueva">Nueva contraseña (mín. 6 - máx. 10)</label>
            <div class="ds-field__control clave__control">
              <input
                id="clave-nueva"
                class="ds-field__input clave__input"
                [type]="showPassword ? 'text' : 'password'"
                formControlName="password"
                [class.is-invalid]="passwordNoValido"
                placeholder="Ingrese la nueva contraseña"
                autocomplete="off">
              <button type="button" class="clave__toggle"
                (click)="showPassword = !showPassword"
                [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'">
                <i class="far" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
              </button>
            </div>
            <small class="clave__error" *ngIf="passwordNoValido">La contraseña debe tener entre 6 y 10 caracteres.</small>
          </div>

          <div class="ds-field">
            <label class="ds-field__label" for="clave-confirmar">Confirmar nueva contraseña</label>
            <div class="ds-field__control clave__control">
              <input
                id="clave-confirmar"
                class="ds-field__input clave__input"
                [type]="showPasswordConfirm ? 'text' : 'password'"
                formControlName="confirmPassword"
                [class.is-invalid]="confirmPasswordNoValido"
                placeholder="Confirme la nueva contraseña"
                autocomplete="off">
              <button type="button" class="clave__toggle"
                (click)="showPasswordConfirm = !showPasswordConfirm"
                [attr.aria-label]="showPasswordConfirm ? 'Ocultar contraseña' : 'Mostrar contraseña'">
                <i class="far" [ngClass]="showPasswordConfirm ? 'fa-eye-slash' : 'fa-eye'"></i>
              </button>
            </div>
            <small class="clave__error" *ngIf="confirmPasswordNoValido">Las contraseñas no coinciden.</small>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="ds-modal__actions">
    <button type="button" class="ds-pill ds-pill--ghost" (click)="closeModal()">Cancelar</button>
    <button type="button" class="ds-pill ds-pill--primary" [disabled]="form.invalid || btnActualizar" (click)="actualizarClave()">
      <span class="material-icons">save</span>
      Aceptar
    </button>
  </div>
</div>
